import React from 'react';

const AdminApprovalRulesPanel = ({ approvedDriverCount }) => (
  <div className="admin-panel admin-sidebar-panel">
    <div className="section-heading mb-4">
      <h2>Approval Rules</h2>
      <p>The frontend now enforces the approval gate before the driver trip dashboard is available.</p>
    </div>

    <ul className="admin-rule-list">
      <li>Customer accounts use role <strong>user</strong>.</li>
      <li>Driver accounts use role <strong>driver</strong>.</li>
      <li>Admin access uses username <strong>admin</strong> and role <strong>admin</strong>.</li>
      <li>Unapproved drivers can sign up and log in, but trip data stays hidden.</li>
    </ul>

    <div className="approved-driver-summary">
      <span className="summary-eyebrow">Approved Drivers</span>
      <h3>{approvedDriverCount}</h3>
      <p>These drivers can access trip and order details after approval.</p>
    </div>
  </div>
);

export default AdminApprovalRulesPanel;
